// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__293pn","rootNoMargin":"styles_rootNoMargin__Pkqn8"};